import React, {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import axios from 'axios';
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Pagination from 'react-bootstrap/Pagination';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { useRef } from 'react';
import carrito from '../imgs/carrito.png';
import { useLocation } from 'react-router-dom'


const Tab3 = ({cli}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
 
  const [data, setData] = useState([]);
  const [modalAbierta, setModalAbierta] = useState(false);
  const [datosModal, setDatosModal] = useState([]);
  const [prodidModal, setProdidModal] = useState(null);
  const [carroItems, setCarroItems] = useState([]);
  const [cantidadCarro, setCantidadCarro] = useState('');
  const [lineas, setLineas] = useState([]);
  const [lineaSeleccionada, setLineaSeleccionada] = useState('');
  const [marcas, setMarcas] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState('');
  const [motivosSeleccionados, setMotivosSeleccionados] = useState({});
  const [motivos, setMotivos] = useState([]);
  const [sumaPotenciales, setSumaPotenciales] = useState(null);
  const [aplicaciones, setAplicaciones] = useState({});
  const [productos2, setProductos2] = useState([]);

  const location = useLocation();
  const productos = new URLSearchParams(location.search).get("productos");

  const [productosHabilitados, setProductosHabilitados] = useState([new Set]);

  useEffect(() => {
    // Divide la cadena de productos en un array y establece el estado
    setProductosHabilitados(new Set(productos ? productos.split(',') : []));
  }, [productos]);

  //const [data2, setData2] = useState([]);

  function formatearNumero(numero) {
    if (numero == null) {
      numero = 0;
    }
    return numero.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }


  useEffect(() => {
    const fetchAplicaciones = async () => {
      console.log("⏳ Ejecutando fetchAplicaciones con productos:", productos2);
  
      const nuevasAplicaciones = {};
      for (const item of productos2) {
        try {
          const res = await axios.get(`https://apiautomarcobi.automarco.cl:3004/api/aplicacion-principal/${item.prod_id}`);
          console.log(`✅ Aplicación para ${item.prod_id}:`, res.data);
          nuevasAplicaciones[item.prod_id] = res.data;
        } catch (err) {
          console.error(`❌ Error en producto ${item.prod_id}`, err);
          nuevasAplicaciones[item.prod_id] = "No disponible";
        }
      }
  
      setAplicaciones(nuevasAplicaciones);
    };
  
    // ⚠️ Verificamos que haya datos antes de ejecutar la función
    if (Array.isArray(productos2) && productos2.length > 0) {
      fetchAplicaciones();
    } else {
      console.log("🟡 productos2 vacío, no se ejecuta fetchAplicaciones.");
    }
  }, [productos2]);
  
  

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const response = await axios.get('https://apiautomarcobi.automarco.cl:3004/api/sumaPotenciales', {
          params: {
            ven: cli,
            bus: '' // Cambia esto por el valor que necesites
          }
        });
        if (response.data && response.data[0]) {
          setSumaPotenciales(response.data[0].suma_total);
        }
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    };

    cargarDatos();
  }, []);

  const loadData = async () => {
        

        // let buscar = document.getElementById('types_input').value;
        await axios.get("https://apiautomarcobi.automarco.cl:3004/api/potenciales", {
            params: {
              ven:  cli ,
            }
        }).then((response) => {
            
            setData(response.data);
            
         })
     
        
  };

  const loadModalData = async (prodid) => {
    try {
      const response = await axios.get("https://apiautomarcobi.automarco.cl:3004/api/aplicaciones", {
        params: {
            prodid: prodid
        }
      });
      const modalData = response.data;
      
      // Aquí puedes utilizar modalData para llenar tu modal con la información necesaria
    
      setDatosModal(modalData);
      setProdidModal(prodid);
      //console.log(modalData);
    } catch (error) {
      console.error('Error al cargar datos de la modal:', error);
    }
  };
  
  const effectRan = useRef(false);

  useEffect(() => {
    const input = document.getElementById('search');
    if (input) {
        input.setAttribute('autocomplete', 'off');
    }
    if (!effectRan.current) {
    loadData();
    }
    return () => {effectRan.current = true};
  },[]);

useEffect(() => {
    const fetchLineas = async () => {
        try {
            const response = await axios.get("https://apiautomarcobi.automarco.cl:3004/api/select-lineas-potenciales", {
              params: {
                ven:  cli,
                bus: '',
              }
            });
            setLineas(response.data);
        } catch (error) {
            console.error('Error al obtener las líneas:', error);
        }
    };

    fetchLineas();
}, []);

useEffect(() => {
  const fetchMarcas = async () => {
      try {
          const response = await axios.get("https://apiautomarcobi.automarco.cl:3004/api/select-marcas-potenciales", {
            params: {
              ven:  cli,
              bus: '',
            }
          });
          setMarcas(response.data);
      } catch (error) {
          console.error('Error al obtener las marcas:', error);
      }
  };

  fetchMarcas();
}, []);

// Llamada a la API para obtener motivos
useEffect(() => {
  const fetchMotivos = async () => {
    try {
      const response = await axios.get("https://apiautomarcobi.automarco.cl:3004/api/select-motivos");
      setMotivos(response.data);
    } catch (error) {
      console.error('Error al obtener los motivos:', error);
    }
  };

  fetchMotivos();
}, []);

  const formatoNumero = (numero) => {
    return numero.toLocaleString('es-ES');
  };

  const abrirModal = (prodid) => {
    // Aquí puedes agregar la lógica para obtener los datos de MySQL para el registro específico
    // Puedes usar una función asíncrona y await para hacer la consulta a la base de datos

    // Ejemplo simulado de una función asíncrona ficticia para obtener datos de MySQL
    loadModalData(prodid).then(() => {
        setModalAbierta(true);
      });
    
};

  const cerrarModal = () => {
    setModalAbierta(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Manejo del cambio en el número de registros por página 
  const handleItemsPerPageChange = (e) => { 
    setItemsPerPage(Number(e.target.value)); 
    setCurrentPage(1); // Resetear a la primera página
  };

  const obtenerProdId = (item) => {
    return item.prod_id;
  };

  const handleCantidadChange = (prodId, e) => {
    let nuevaCantidad = e.target.value;
  
    // Validar que la cantidad sea un número y mayor o igual a 0
    const cantidadNumerica = parseInt(nuevaCantidad, 10);
    if (/^\d*$/.test(nuevaCantidad) && cantidadNumerica >= 0) {
      // Evitar que se ingrese un cero al comienzo
      if (nuevaCantidad.length === 1 && nuevaCantidad === "0") {
        nuevaCantidad = "";
      }
  
      setCantidadCarro((prevCantidad) => ({
        ...prevCantidad,
        [prodId]: nuevaCantidad
      }));
    } else {
      // Si la validación falla, o se ingresó un valor no válido, puedes mostrar un mensaje de error o realizar otra acción
      console.error('Ingrese un número válido mayor o igual a 0');
    }
  };
  
  /*const handleMotivoChange = (prodId, e) => {
    const motivo = e.target.value;
    setMotivosSeleccionados(prevMotivos => ({
        ...prevMotivos,
        [prodId]: motivo
    }));
};*/
const handleMotivoChange = (prodId, e) => {
  setMotivosSeleccionados({
    ...motivosSeleccionados,
    [prodId]: e.target.value
  });
};

const guardarMotivos = async () => {
  const itemsAGuardar = Object.entries(motivosSeleccionados).map(([prodId, motivo]) => ({
      prodId,
      motivo,
      rutcli: cli // Asegúrate de que `cli` es el cliente correcto
      
  }));

  if (itemsAGuardar.length === 0) {
      toast.error('Debe seleccionar al menos un motivo.');
      return;
  }

  try {
      await axios.post('https://apiautomarcobi.automarco.cl:3004/api/guardar-motivos-pot', {
          rutcli: cli,
          motivos: itemsAGuardar
      });
      toast.success('Motivos guardados con éxito.');
      loadData();
  } catch (error) {
      toast.error('Error al guardar los motivos.');
      console.error('Error al guardar los motivos:', error);
  }
};

  const handleKeyDown = (e, prodId) => {
    // Permitir eliminar el último dígito con la tecla "Backspace"
    if (e.key === 'Backspace') {
      setCantidadCarro((prevCantidad) => ({
        ...prevCantidad,
        [prodId]: (prevCantidad[prodId] || '').slice(0, -1)
      }));
    }
  };

  const agregarAlCarro = async () => {

    const sucursal = cli.slice(-1);
    const dv = cli.slice(-2, -1);
    const rutBase = cli.slice(0, -2);
    const rutCompleto = `${rutBase}-${dv}`;
    
    const itemsSeleccionados = data.map(item => {
      const prodId = obtenerProdId(item);
      const cantidad = cantidadCarro[prodId] && cantidadCarro[prodId].trim() !== '' ? cantidadCarro[prodId] : '0';
      const precio = item.prod_precio; 
      return { prodId, cantidad, precio };
    });

    const itemsValidos = itemsSeleccionados.filter(item => item.cantidad !== '0');

    if (itemsValidos.length > 0) {

      // Enviar a Node para guardar en log_movimientos_bi
        try {
            await fetch('https://apiautomarcobi.automarco.cl:3004/api/log-movimientos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    rutCompleto,
                    sucursal,
                    accion: 'bi potenciales',
                    items: itemsValidos
                })
            });
        } catch (error) {
            console.error("Error al guardar log:", error);
        }

      console.log('Agregado al carro:', itemsValidos);
      setCantidadCarro({});
      setCarroItems([...carroItems, ...itemsValidos]);
      if (typeof window.Android !== 'undefined') {
        window.Android.recibirDatos(JSON.stringify(itemsValidos));
      }
      //Android.recibirDatos(JSON.stringify(itemsValidos));
    } else {
      toast.error('Por favor, ingresa una cantidad válida.');
    }
  };

  const handleCombinedAction = () => {
    agregarAlCarro();
    guardarMotivos();
  };
  // Calcula el índice de inicio y fin para los elementos de la página actual
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Filtra los elementos a mostrar en la página actual
  const itemsFiltrados = data.filter((item) => {
    const lineaMatch = !lineaSeleccionada || item.cla_nombre === lineaSeleccionada;
    const marcaMatch = !marcaSeleccionada || item.marca_nombre === marcaSeleccionada; // Asumiendo que el campo para la marca en los datos se llama `marca_nombre`
  
    return lineaMatch && marcaMatch;
  });
  const totalFilteredPages = Math.ceil(itemsFiltrados.length / itemsPerPage);
  const itemsFiltrados2 = itemsFiltrados.slice(startIndex, endIndex);
  

  const maxVisiblePages = 10;
  const currentBlock = Math.ceil(currentPage / maxVisiblePages);
  const startPage = (currentBlock - 1) * maxVisiblePages + 1;
  const endPage = Math.min(startPage + maxVisiblePages - 1, totalFilteredPages);

  useEffect(() => {
    setProductos2(itemsFiltrados.slice(startIndex, endIndex));
  }, [startIndex, endIndex, lineaSeleccionada, marcaSeleccionada, data]);

console.log('currentPage:', currentPage);
console.log('itemsFiltrados.length:', itemsFiltrados.length);
console.log('Total Pages:', Math.ceil(itemsFiltrados.length / itemsPerPage));

 
  

  return (
    <><h3 className='titulo'>Productos Potenciales</h3><div style={{ marginTop: "30px", marginLeft: "10px", marginRight: "0px" }}>
      <Table size="sm" style={{ width: '40%' }}> 
        <thead> 
          <tr> 
            <th>Si compran 2 de cada ítem</th> 
            
          </tr> 
        </thead> 
        <tbody> 
          <tr> 
          <td>${sumaPotenciales !== null ? formatearNumero(sumaPotenciales) : 'Cargando...'}</td>
          
          </tr> 
        </tbody> 
      </Table>
      <div className='form-inline'>
        <div id="field_wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <select className="form-select" style={{ marginLeft: '10px', width: '200px', fontSize: '12px' }} value={marcaSeleccionada}
            onChange={(e) => setMarcaSeleccionada(e.target.value)}>

            <option value="">Selecciona una marca</option>
            {marcas.map((marca) => (
              <option key={marca.marca_nombre} value={marca.marca_nombre}>
                {marca.marca_nombre}
              </option>
            ))}

          </select>

          <select className="form-select" style={{ marginLeft: '10px', width: '200px', fontSize: '12px' }} value={lineaSeleccionada}
            onChange={(e) => setLineaSeleccionada(e.target.value)}>

            <option value="">Selecciona una línea</option>
            {lineas.map((linea) => (
              <option key={linea.cla_nombre} value={linea.cla_nombre}>
                {linea.cla_nombre}
              </option>
            ))}

          </select>
          </div>
                    <div style={{ marginLeft: 'auto' }}>
                        <select className="form-select"
                            style={{ width: '120px', fontSize: "12px" }} value={itemsPerPage}
                            onChange={handleItemsPerPageChange}>
                            <option value={10}>Mostrar 10</option>
                            <option value={20}>Mostrar 20</option>
                        </select>
                    </div>
        </div>
      </div>
      <br></br>
      <div className="my-class-form-control-group">
        <Table size="sm" className='titulos_tablas table-custom'>
          <thead>
            <tr>
              <th>Frecuentes</th>
              <th>Cod. Fabrica</th>
              <th>Linea</th>
              <th>Marca</th>
              <th>Precio</th>
              <th>Stock</th>
              <th>Aplicaciones</th>
              <th>Unidades</th>
              <th></th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            {itemsFiltrados2.length === 0 ? (
              <tr className="even-row" >
                <td colSpan="8"  style={{ textAlign: "center" }}>
                  No hay resultados
                </td>
              </tr>
            ) : (
              itemsFiltrados2.map((item, index) => {
                //const [data2, setData2] = useState([]);
                return (


                  <tr className={index % 2 === 0 ? 'even-row' : 'odd-row'} style={{ textAlign: "left" }} key={item.prod_id}>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'nowrap' }}>{item.prod_id}</td>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'pre-line' }}>{item.id_prov}</td> 
                    <td style={{ borderBottomWidth: "0px", whiteSpace: 'nowrap', width: "18%" }}>
                      {item.cla_nombre}
                      <br />
                      <span style={{ fontSize: '11px', color: '#555' }}>
                        {aplicaciones[item.prod_id] || 'Cargando...'}
                      </span>
                    </td>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'nowrap' }}> {item.marca_nombre}</td>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'nowrap' }}> ${formatoNumero(item.prod_precio)}</td>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'nowrap' }}> {formatoNumero(item.prod_stock)}</td>
                    <td style={{ borderBottomWidth: "0px", width: "12%", whiteSpace: 'nowrap' }}> <Button onClick={() => abrirModal(item.prod_id)} style={{ fontSize: "12px" }}>Apli.</Button></td>
                    <td style={{ borderBottomWidth: "0px", width: "16%", whiteSpace: 'nowrap' }}> {item.multiplo ? (
                      <InputGroup>

                        <InputGroup.Text id="basic-addon2">
                          <select
                            value={cantidadCarro[item.prod_id] || ''}
                            onChange={(e) => handleCantidadChange(item.prod_id, e)}
                            >
                              <option value="">Sel.</option>
                            {[...Array(100 / item.multiplo)].map((_, i) => (
                              <option key={i + 1}>{item.multiplo * (i + 1)}</option>
                            ))}
                          </select>
                        </InputGroup.Text>
                      </InputGroup>
                    ) : (
                      <FormControl
                        type="text"
                        value={cantidadCarro[item.prod_id] || ''}
                        onChange={(e) => handleCantidadChange(item.prod_id, e)}
                        onKeyDown={(e) => handleKeyDown(e, item.prod_id)}
                        style={{ width: "60px" }}
                        inputMode="numeric"
                        pattern="[0-9]*"
                         />
                    )}</td>
                    <td style={{ borderBottomWidth: "0px", width: "16%", whiteSpace: 'nowrap' }}>
                                            {productosHabilitados.has(item.prod_id) && (
                                               <img src={carrito} alt="Carrito" width="25" />
                                            )}
                                        </td>
                    <td>
                    <select
                      value={motivosSeleccionados[item.prod_id] || ''}
                      onChange={(e) => handleMotivoChange(item.prod_id, e)} 
                      style={{ width: "100px" }}
                    >
                      <option value="">Selecciona un motivo</option>
                      {motivos.map((motivo) => (
                        <option key={motivo.id_motivo} value={motivo.id_motivo}>
                          {motivo.motivo}
                        </option>
                      ))}
                    </select>
                    </td>
                  </tr>
                );
              })
            )}

          </tbody>
        </Table>
        <Modal show={modalAbierta} onHide={cerrarModal}>
          <Modal.Header closeButton>
            <Modal.Title>{`Aplicaciones - Producto ${prodidModal || ''}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table size="sm">
              <thead>
                <tr>
                  <th>Marca</th>
                  <th>Modelo</th>
                  <th>Cilindrada</th>
                  <th>Año Inicio</th>
                  <th>Año Término</th>


                </tr>
              </thead>
              <tbody>
                {datosModal.map((item, index) => {
                  return (
                    <tr style={{ textAlign: "left" }} key={item.pm_id}>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.marca_nombre}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.mod_id}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}> {item.cilindrada}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}> {item.inicio}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}> {item.fin}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>


            {/* Agrega más campos según tus datos personalizados */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={cerrarModal}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Pagination>
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)} />
        {Array.from({ length: (endPage - startPage + 1) }, (_, index) => (
          <Pagination.Item
            key={startPage + index}
            active={startPage + index === currentPage}
            onClick={() => handlePageChange(startPage + index)}
          >
            {startPage + index}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={currentPage === totalFilteredPages}
          onClick={() => handlePageChange(currentPage + 1)} />
      </Pagination>
      <Button variant="primary" onClick={handleCombinedAction} style={{ float: 'right', marginRight: '10px', fontSize: "12px" }}>
        Grabar / Agregar al Carro
      </Button>
      
    </div></>
    
  )
}

export default Tab3;